
export default function DifferentialsSection() {
  const differentials = [
    {
      icon: 'ri-lightbulb-line',
      title: 'DNA Inovador',
      description:
        'Somos uma consultoria estratégica que une profundo conhecimento de mercado com tecnologias de ponta, entregando soluções inteligentes e alinhadas às tendências globais. Todos os dias dividimos estratégias, que multiplicam resultados.',
      image:
        'https://public.readdy.ai/ai/img_res/3112e3abc693146ebdc1dd100ac44b7c.jpg',
    },
    {
      icon: 'ri-team-line',
      title: 'Foco em Parcerias Estratégicas',
      description:
        'Mais que próximos, somos parceiros de negócio. Atuamos lado a lado com nossos clientes, cocriando estratégias que geram resultados concretos e diferenciais competitivos.',
      image:
        'https://readdy.ai/api/search-image?query=close%20collaboration%20between%20business%20teams%2C%20modern%20office%20environment%2C%20professionals%20working%20together%20with%20AI%20technology%2C%20sophisticated%20workspace%20with%20digital%20screens%20and%20data%20visualization&width=600&height=400&seq=collaboration&orientation=landscape',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Quebra de Paradigmas',
      description:
        'Não oferecemos fórmulas mágicas e prontas. Cada Cliente é único. Cada estratégia, exclusiva. Por isso, nossas soluções são desenhadas sob medida, com foco em relevância, impacto e diferenciação comercial.',
      image:
        'https://readdy.ai/api/search-image?query=customized%20AI%20solutions%20dashboard%2C%20personalized%20technology%20interface%2C%20tailored%20business%20software%2C%20modern%20digital%20workspace%20with%20custom%20analytics%20and%20data%20visualization&width=600&height=400&seq=personalized&orientation=landscape',
    },
  ];

  return (
    <section id="differentials" className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nossos Diferenciais
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            O que nos torna únicos no mercado de IA e automação para vendas
          </p>
        </div>

        <div className="space-y-20">
          {differentials.map((differential, index) => (
            <div
              key={index}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } items-center gap-12`}
            >
              {/* Content */}
              <div className="flex-1 space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
                    <i className={`${differential.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-3xl font-bold text-white">
                    {differential.title}
                  </h3>
                </div>
                
                <p className="text-lg text-gray-300 leading-relaxed">
                  {differential.description}
                </p>

                <div className="flex items-center flex-wrap gap-4 text-sm text-gray-400">
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-400 mr-2"></i>
                    {index === 1 ? 'Sinergia' : index === 2 ? 'Insights' : 'Inteligência'}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-400 mr-2"></i>
                    {index === 1 ? 'Diferenciação' : index === 2 ? 'Machine Learning' : 'Escalabilidade'}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-400 mr-2"></i>
                    {index === 1 ? 'Confiança' : index === 2 ? 'Data Driven' : 'Agilidade'}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-400 mr-2"></i>
                    {index === 1 ? 'Excelência' : index === 2 ? 'IA Generativa' : 'Transformação'}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-400 mr-2"></i>
                    {index === 1 ? 'Valor' : index === 2 ? 'Platform' : 'Precisão'}
                  </div>
                </div>
              </div>

              {/* Image */}
              <div className="flex-1">
                <div className="relative overflow-hidden rounded-2xl">
                  <img
                    src={differential.image}
                    alt={differential.title}
                    className="w-full h-80 object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
